import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

const StyledTaxesSection = styled('section')`
  color: ${({ theme }) => getEmbeddedViewFlag() ? theme.secondary.base : theme.gray.medium};
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding: 4px 0;
  width: 100%;
`

const TaxDetails = ({ tax_label, tax_amount }) => (
  <StyledTaxesSection>
    <span>{__('{%s, 0}', [tax_label])}</span>
    <span>{__('({%m, 0} tax)', [tax_amount])}</span>
  </StyledTaxesSection>
)

TaxDetails.propTypes = {
  tax_label: PropTypes.string,
  tax_amount: PropTypes.number,
}

export default TaxDetails
